"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _siteSearchContext = require("../site-search-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchItemContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchItemContainer",
  class: "pl-sng3hgq"
});

/**
 * Search Banner Component
 * @module SearchItem
 *
 * @param {String} props.title Suggestion Title
 * @returns {React.ReactElement} Search Banner Component
 * @public
 */

function SearchItem({
  title,
  trackingEid,
  trackingCustomProperties
}) {
  const {
    handleOnConfirm
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  return /*#__PURE__*/_react.default.createElement(SearchItemContainer, (0, _extends2.default)({
    "data-cy": "term-item",
    onClick: () => handleOnConfirm(title)
  }, _patternLibraryUtils.tracking.create(trackingEid, true, false, trackingCustomProperties)), title);
}
SearchItem.propTypes = {
  title: _propTypes.default.string,
  trackingEid: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object
};